import axios from 'axios/index';
import {defaultBehaviour} from "../utils/ServiceUtils";

function getConfigurationByLangId(keyName, langId, okCallback, koCallback) {
    return defaultBehaviour(axios.get(`/config/configTranslation/${keyName}/${langId}`), okCallback, koCallback);
}

export default { getConfigurationByLangId };